export default __webpack_public_path__ + "img/en.8c022f1a.svg";